import {
  Redirect,
  Stack,
  useLocalSearchParams,
  usePathname,
} from 'expo-router';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';

import Home from '@/components/home';
import mixpanelService from '@/core/clients/mixpanel';
import useSettingsStore from '@/stores/use-settings-store';

export default function Index() {
  const pathname = usePathname();
  const { ref, promo } = useLocalSearchParams();
  const setRefCode = useSettingsStore((state) => state.setRefCode);
  const setPromoCode = useSettingsStore((state) => state.setPromoCode);

  useEffect(() => {
    if (ref) {
      setRefCode(ref as string);
    }
  }, [ref, setRefCode]);

  useEffect(() => {
    if (promo) {
      setPromoCode(promo as string);
    }
  }, [promo, setPromoCode]);

  useEffect(() => {
    if (pathname !== '/') return;

    mixpanelService.track('Page Viewed', {
      'Page Name': 'Home',
    });
  }, [pathname]);

  if (Platform.OS !== 'web') {
    return <Redirect href="/search" />;
  }

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <Home />
    </>
  );
}
